import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../../app/core/services/common.service';

export interface ContentPoolStatus {
  id: number;
  name: string;
  status: 'active' | 'pending' | 'deleted';
  partnerId?: number | string;
  parentElementId?: number | string;
}

@Component({
  selector: 'app-content-pool-status',
  imports: [CommonModule],
  templateUrl: './content-pool-status.html',
  styleUrl: './content-pool-status.scss'
})
export class ContentPoolStatusComponent implements OnInit {
  contentPools: ContentPoolStatus[] = [];
  @Input() maxDisplayItems: number = 5;


  activePools: ContentPoolStatus[] = [];
  pendingPools: ContentPoolStatus[] = [];
  deletedPools: ContentPoolStatus[] = [];
  activePartnerIds: string[] = [];
  pendingPartnerIds: string[] = [];
  deletedPartnerIds: string[] = [];
  activeAdvertiserIds: string[] = [];
  pendingAdvertiserIds: string[] = [];
  deletedAdvertiserIds: string[] = [];
  activeParentElementIds: string[] = [];
  pendingParentElementIds: string[] = [];
  deletedParentElementIds: string[] = [];
  activeTTDSegment: string[] = [];
  pendingTTDSegment: string[] = [];
  deletedTTDSegment: string[] = [];
  updatedPartnerIds: ContentPoolStatus[] = [];
  updatedProviderElementId: ContentPoolStatus[] = [];
  ttdSegmentStatus:ContentPoolStatus[] = [];
  advertiserIdStatus:ContentPoolStatus[] = [];
  constructor(private commonService: CommonService){

  }

  ngOnInit(): void {
    this.categorizeContentPools();
    this.commonService.getShareContentPoolStatus().subscribe((contentPoolStatus: any) => {
      this.contentPools = contentPoolStatus.contentPoolStatus || [];
      this.updatedPartnerIds = contentPoolStatus.partnerIdStatus || [];
      this.updatedProviderElementId = contentPoolStatus.providerElementIdStatus || [];
      this.ttdSegmentStatus =  contentPoolStatus.ttdSegmentStatus || [];
      this.advertiserIdStatus =  contentPoolStatus.advertiserIdsStatus || [];
      this.categorizeContentPools();
    })
  }

  private categorizeContentPools(): void {
    const poolGroups: Record<'active' | 'pending' | 'deleted', ContentPoolStatus[]> = {
      active: [],
      pending: [],
      deleted: []
    };
    for (const pool of this.contentPools) {
      poolGroups[pool.status].push(pool);
    }
    this.activePools = poolGroups.active;
    this.pendingPools = poolGroups.pending;
    this.deletedPools = poolGroups.deleted;

    const groupNamesByStatus = (items: ContentPoolStatus[]) => {
      const groups: Record<'active' | 'pending' | 'deleted', string[]> = {
        active: [],
        pending: [],
        deleted: []
      };
      for (const item of items) {
        if(!groups[item.status].includes(String(item.name))){
            groups[item.status].push(String(item.name));
        }
      }
      return groups;
    };

    const partnerGroups = groupNamesByStatus(this.updatedPartnerIds);
    this.activePartnerIds = partnerGroups.active;
    this.pendingPartnerIds = partnerGroups.pending;
    this.deletedPartnerIds = partnerGroups.deleted;

    const advertiserGroups = groupNamesByStatus(this.advertiserIdStatus);
    this.activeAdvertiserIds = advertiserGroups.active;
    this.pendingAdvertiserIds = advertiserGroups.pending;
    this.deletedAdvertiserIds = advertiserGroups.deleted;

    const providerGroups = groupNamesByStatus(this.updatedProviderElementId);
    this.activeParentElementIds = providerGroups.active;
    this.pendingParentElementIds = providerGroups.pending;
    this.deletedParentElementIds = providerGroups.deleted;

    const ttdGroups = groupNamesByStatus(this.ttdSegmentStatus);
    this.activeTTDSegment = ttdGroups.active;
    this.pendingTTDSegment = ttdGroups.pending;
    this.deletedTTDSegment = ttdGroups.deleted;
  }

  getDisplayPools(pools: ContentPoolStatus[]): ContentPoolStatus[] {
    return pools.slice(0, this.maxDisplayItems);
  }

  getRemainingCount(pools: ContentPoolStatus[]): number {
    return Math.max(0, pools.length - this.maxDisplayItems);
  }

  getTooltipText(pools: ContentPoolStatus[]): string {
    if (pools.length <= this.maxDisplayItems) {
      return pools.map(pool => pool.name).join(', ');
    }
    const displayPools = this.getDisplayPools(pools);
    const remainingPools = pools.slice(this.maxDisplayItems);
    return `${displayPools.map(pool => pool.name).join(', ')} and ${remainingPools.length} more: ${remainingPools.map(pool => pool.name).join(', ')}`;
  }

  getStatusChipClass(status: string): string {
    const statusClassMap: Record<string, string> = {
      'active': 'status-active',
      'pending': 'status-pending',
      'deleted': 'status-deleted'
    };
    return statusClassMap[status] || 'status-pending';
  }

  trackByPoolId(_index: number, pool: ContentPoolStatus): number {
    return pool.id;
  }

  getActivePartnerIds(): Array<string> {
    if(!this.updatedPartnerIds.length) return [];
    return this.activePartnerIds;
  }

  getParentElementIds(): Array<string> {
    if(!this.updatedProviderElementId) return [];
    return this.activeParentElementIds;
  }

  getDisplayIds<T>(items: T[]): T[] {
    return items.slice(0, this.maxDisplayItems);
  }

  getRemainingCountForIds<T>(items: T[]): number {
    return Math.max(0, items.length - this.maxDisplayItems);
  }


}
